/* eslint-disable no-nested-ternary */
import React, { useMemo, useContext, useEffect, useState } from 'react';
import loadable from '@loadable/component';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
// import Animation from 'ls-common-client/dist/components/Animation';
// import { Redirect } from 'react-router-dom';
// import profileLoader from '../../animations/profileLoader.json';
import AddABusiness from '../../components/AddABusiness';
import ScrollToTop from '../../components/ScrollToTop';
import ReviewForm from '../../components/ReviewForm';
import { Context } from '../../context/AppContext';
import slugify from '../../utils/slugify';
import getFullStateName from '../../utils/getFullStateName';
import locationUrl from '../../utils/locationUrl';
import findUrl from '../../utils/findUrl';
// import useSsr from '../../hooks/useSsr';
import useContextApi from '../../hooks/useContextApiSpeed';
import LazyLoad from '../../components/LazyLoad';
import Meta from './Meta';
import Top from '../../components/Landing/Top';
import ArcBackground from '../../components/Landing/Background/Arc';
import UrlList from '../../components/Landing/UrlList';
import About from '../../components/Landing/About';
import PopularIndustries from '../../components/Landing/PopularIndustries';
import ReadMore from '../../components/Landing/About/ReadMore';
import BreadcrumbsBottom from '../../components/Landing/BreadcrumbsBottom';
import redirects from './redirects';
import {
  // searchSeoRegionQuery,
  searchSuggestSuburbsQuery,
} from '../../gql/search';
import SearchWrapper from '../../components/Search/context/Search';
import useInitialSearch from '../../components/Search/hooks/useInitialSearch';
import categories from './categories';
import NextLink from '../../components/NextLink';

const NotFound = loadable(() => import('../NotFound'));
const QuoteEnquiries = loadable(() =>
  import('../../components/Landing/QuoteEnquiries')
);
const AppDownload = loadable(() =>
  import('../../components/Landing/AppDownload')
);
const B2bSection = loadable(() => import('../../components/B2bSection'));
const FeatureReviews = loadable(() =>
  import('../../components/Landing/FeatureReviews')
);
const ListYourBusiness = loadable(() =>
  import('../../components/Landing/ListYourBusiness')
);
const DigitalMarketingBanner = loadable(() =>
  import('../../components/DigitalMarketingBanner')
);
const HoverIcon = loadable(() => import('../../components/HoverIcon'));
const TopRatedBusinesses = loadable(() =>
  import('../../components/Landing/TopRatedBusinesses')
);
const SponsoredBusinesses = loadable(() =>
  import('../../components/Landing/SponsoredBusinesses')
);
const PopularCategories = loadable(() =>
  import('../../components/Landing/PopularCategories')
);
const PopularRegions = loadable(() =>
  import('../../components/Landing/PopularRegions')
);
const TopBusinesses = loadable(() =>
  import('../../components/Landing/TopBusinesses')
);

const StyledRoot = styled(Container)`
  background: #ffffff;
  .Popular_SearchesList {
    padding-top: 0;
  }
`;

// const ssr = ({ params, redirect, pathname }) => {
//   const { region } = params;

//   return [
//     {
//       name: 'SeoRegion',
//       query: searchSeoRegionQuery,
//       variables: {
//         params: {
//           region,
//           allSuburbs: true,
//         },
//       },
//       callback: async (data, errors) => {
//         const url = await redirects({ params, data, pathname, errors });
//         return url ? redirect(url) : false;
//       },
//     },
//   ];
// };

const ssr = ({ params, redirect, pathname }) => {
  const { region } = params;

  return [
    {
      api: 'SeoRegion',
      options: {
        params: {
          region,
          allSuburbs: true,
        },
      },
      callback: async (data, errors) => {
        const url = await redirects({ params, data, pathname, errors });
        return url ? redirect(url) : false;
      },
    },
  ];
};

const Region = ({ match }) => {
  const { params } = match || {};
  const { region: paramRegion, state: paramState } = params;

  // const { SeoRegion, redirectUrl } = useSsr(ssr);  # REVERT GRAPHQL
  const { SeoRegion } = useContextApi(ssr);

  const { data: SuggestSuburbsData, loading } = useQuery(
    searchSuggestSuburbsQuery,
    {
      variables: {
        params: {
          keyword: paramRegion,
          state: paramState,
        },
      },
    }
  );

  const [urlSlug, setUrlSlug] = useState();
  const {
    userLocation: { location },
    media: { mobile, tablet },
  } = useContext(Context);

  // const { searchSeoRegion } = SeoRegion || {}; # REVERT GRAPHQL
  // const { data, links } = searchSeoRegion || {};
  const { data, links } = SeoRegion || {};

  const { breadcrumbs } = links || {};
  const { attributes } = (data && data[0]) || {};
  const {
    name,
    state,
    description,
    geolocation: geo,
    popular_categories: popularCategories = [],
    popular_suburbs: popularSuburbs = [],
    sponsored_businesses: sponsoredBusinesses = [],
  } = attributes || {};

  const { url_name: locationSlug } = location;

  const { searchSuggestSuburbs } = SuggestSuburbsData || {};
  const { data: suburbData } = searchSuggestSuburbs || {};

  useEffect(() => {
    if (suburbData && !!suburbData.length) {
      const regionData = suburbData.filter(
        ({ suburbName }) => suburbName === name
      );
      const { url_name: urlName, urlSlug: urlslug } =
        (regionData && regionData[0]) || {};
      setUrlSlug(urlName || urlslug);
    }
  }, [suburbData, name]);

  const fullStateName = useMemo(() => getFullStateName(state), [state]);
  const showPopularSearches =
    match.url === '/nsw/sydney' || match.url === '/vic/melbourne';

  // if (redirectUrl) # REVERT GRAPHQL
  //   return (
  //     <StyledRoot>
  //       <Container width="150px" margin="0 auto">
  //         <Animation data={profileLoader} width="150px" />
  //       </Container>
  //       <Redirect to={redirectUrl} />
  //     </StyledRoot>
  //   );

  const initialSearch = useInitialSearch();
  if (!loading && !name) {
    return <NotFound />;
  }
  return (
    <StyledRoot className="Region__root">
      <ScrollToTop />
      <Meta
        name={name}
        state={state}
        fullStateName={fullStateName}
        canonical={match.url}
        description={`Discover the best mechanics, plumbers, hairdressers, builders, restaurants and more in the ${name} on Localsearch! See what other locals are searching for right now.`}
      />
      <SearchWrapper initialSearch={initialSearch}>
        <Top
          heading={
            <>
              <span>Find the businesses you need in</span> {name}
            </>
          }
          subHeading={fullStateName}
        />
      </SearchWrapper>
      <ArcBackground>
        {popularCategories && !!popularCategories.length && (
          <PopularIndustries
            title={`Popular industries in ${name}`}
            data={popularCategories}
            locationSlug={urlSlug}
            shuffle
          />
        )}
        <About
          description={description}
          geo={geo}
          location={name}
          state={state}
          b2bStyle={mobile ? 'vertical' : 'horizontal'}
        />
      </ArcBackground>
      {showPopularSearches && (
        <UrlList
          title={`Popular Searches for ${name}`}
          className="Popular_SearchesList"
          data={categories}
          columns={3}
          maxWidth="1350px"
          embedTitle
          renderItem={item => (
            <HoverIcon>
              <NextLink
                to={`/find/${item.path}/${slugify(`${name} ${state}`)}`}
              >
                {item.name} in {name}
              </NextLink>
            </HoverIcon>
          )}
        />
      )}
      <LazyLoad>
        {name && (
          <QuoteEnquiries
            name={name}
            params={{
              region: name,
            }}
          />
        )}
      </LazyLoad>
      {description && description.length > 745 ? (
        <ReadMore
          description={description}
          title={`Did you know this about ${name}?`}
        />
      ) : (
        ''
      )}
      <LazyLoad style={{ minHeight: '400px' }}>
        {sponsoredBusinesses && !!sponsoredBusinesses.length && (
          <SponsoredBusinesses data={sponsoredBusinesses} />
        )}
        {name && state && (
          <FeatureReviews
            params={{
              region: name,
              state,
            }}
            title={`Featured Reviews about Local Businesses in ${name}`}
          />
        )}
        <LazyLoad style={{ minHeight: '100px' }}>
          {name && state && (
            <div>
              <TopBusinesses searchAreaPath={slugify(`${name} ${state}`)} />
            </div>
          )}
        </LazyLoad>
        <TopRatedBusinesses
          params={{ first: 4, region: name }}
          title={`Locals recommend these ${name} businesses`}
          subTitle={`Checkout these popular businesses in ${name}`}
        />
      </LazyLoad>
      <LazyLoad
        className="Region__SeoTop"
        style={{
          minHeight: mobile ? '2538px' : tablet ? '1692px' : '1332px',
        }}
      >
        <AppDownload />
        <B2bSection />
      </LazyLoad>
      {popularCategories && !!popularCategories.length && (
        <UrlList
          className="Region__CategoryList"
          title={`Top 100 categories for ${name}`}
          subTitle="See the most popular categories locals are searching for."
          data={popularCategories}
          columns={3}
          renderItem={item => (
            <HoverIcon>
              <a
                href={
                  urlSlug
                    ? findUrl({ keyword: item.name, suburb_url: urlSlug })
                    : `/find/${slugify(item.name)}`
                }
              >
                {item.name}
              </a>
            </HoverIcon>
          )}
        />
      )}
      <LazyLoad
        className="Region__SeoBottom"
        style={{
          minHeight: mobile ? '3342px' : tablet ? '2710px' : '1960px',
        }}
      >
        <PopularRegions />
        <ListYourBusiness
          title={`List your business in ${name}`}
          text={`${name} locals are just waiting to find your business on Localsearch. All it takes to add your business is completing the super quick and easy form—click the button below to go there now. What are you waiting for?`}
        />
        <PopularCategories
          locationSlug={urlSlug || locationSlug}
          title={`Discover businesses in the ${name} area`}
        />
      </LazyLoad>
      <LazyLoad style={{ minHeight: '200px' }}>
        <UrlList
          className="Region__SuburbsList"
          title={`Suburbs in ${name}`}
          subTitle={`Check out these suburbs near ${fullStateName}`}
          data={popularSuburbs.slice(0, 80)}
          toggleData={popularSuburbs.slice(80, popularSuburbs.length)}
          columns={4}
          renderItem={item => (
            <HoverIcon>
              <a href={locationUrl({ breadcrumbs: item.breadcrumbs })}>
                {item.suburb}
              </a>
            </HoverIcon>
          )}
        />
        <DigitalMarketingBanner />
      </LazyLoad>
      <BreadcrumbsBottom breadcrumbs={breadcrumbs} />
      <ReviewForm />
      <AddABusiness />
    </StyledRoot>
  );
};

export { ssr };

export default Region;
